import { useState, useEffect } from "react";

export const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(false);

	const handleResize = () => {
		const isMobileSize = window.innerWidth <= 768;
		setIsMobile(isMobileSize);
	};

	useEffect(() => {
		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return isMobile;
};
